import React from "react";
import { useData } from "../context/data/DataState";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Label } from "../ui/label";

const ClubSeasonInfo = () => {
  const { data, communityId, changeCommunityId, seasonId, changeSeasonId } =
    useData();
  
  return (
    <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor="community">Community</Label>
        <Select value={communityId} onValueChange={changeCommunityId}>
          <SelectTrigger id="community">
            <SelectValue placeholder="Select community" />
          </SelectTrigger>
          <SelectContent>
            {Object.values(data.community || {}).length === 0 && (
              <SelectItem value="none">None</SelectItem>
            )}
            {Object.values(data.community || {}).map((item) => (
              <SelectItem value={item.community_id} key={item.community_id}>
                {item.community_name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor="season">Season</Label>
        <Select value={seasonId} onValueChange={changeSeasonId}>
          <SelectTrigger id="season">
            <SelectValue placeholder="Select season" />
          </SelectTrigger>
          <SelectContent>
            {Object.values(data.community[communityId]?.season || {}).length === 0 && (
              <SelectItem value="none">None</SelectItem>
            )}
            {Object.values(data.community[communityId]?.season || {}).map((item) => (
              <SelectItem value={item.season_id} key={item.season_id}>
                {item.season_name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default ClubSeasonInfo;
